import { mdiArrowRight, mdiLockOpenVariantOutline } from '@mdi/js';
import Icon from '@mdi/react';
import get from 'lodash/get';
import React from 'react';
import { useSelector } from 'react-redux';
import { scroller } from 'react-scroll';
import Slider from 'react-slick';
import { SUBSCRIPTION_REPORTS, SUBSCRIPTION_REPORTS_CARDS } from '../../../../constants';
import { loadMoreInteraction, subscribeClick } from '../../../../helpers/datalayer-utils';
import { BQLink } from '../../../atoms/bqlink';
import ShineButton from '../../../atoms/shine-button';
import './research.reports.m.css';

const ResearchReports = ({ isSubscriber }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  const handleClick = () => {
    subscribeClick(userData, pageType, 'Research Reports');
    scroller.scrollTo('subscription-home', {
      duration: 500,
      delay: 100,
      smooth: 'easeInOutQuart',
    });
  };

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    swipeToSlide: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
    ],
  };
  return (
    <div styleName="pn-our-reader-wrapper">
      <div styleName="pn-our-reader-headerText">
        <img src="/icons/reports-icon.svg" />
        <div styleName="heading">Research Reports</div>
        <div styleName="desc">In-Depth Research from India’s top Analysts</div>
      </div>
      <div>
        <div styleName="slideshow">
          <img src="/images/left-shadow.png" styleName="shadow" />
          <Slider {...settings}>
            {SUBSCRIPTION_REPORTS_CARDS.map((list, index) => (
              <React.Fragment key={index}>
                <div styleName="card" style={{ background: list.cardColor }}>
                  <img src={list.icon} alt={list.icon} />
                  <BQLink href={list.link} styleName="view-btn" style={{ color: list.txtColor }}>
                    View All Reports
                  </BQLink>
                </div>
              </React.Fragment>
            ))}
          </Slider>
          <img src="/images/right-shadow.png" styleName="shadow right" />
        </div>
      </div>
      <div styleName="reports-wrap" className="container">
        {SUBSCRIPTION_REPORTS.map((dl, index) => (
          <div styleName="report-list" key={index}>
            <img src={dl.icon} styleName="report-icons" alt={dl.name} />
            <div styleName="headings">
              <span styleName="name">{dl.name}</span>
              <span styleName="title">{dl.title}</span>
            </div>
          </div>
        ))}
      </div>
      <div styleName="button-wrap" className="container">
        {isSubscriber === false && isSubscriber !== null && (
          <div styleName="report-btn" className="container" onClick={() => handleClick()}>
            <ShineButton
              className="shine-button"
              size="medium"
              label="Subscribe to Unlock"
              icon="left"
              rounded="full"
            >
              <Icon path={mdiLockOpenVariantOutline} size="18px" />
            </ShineButton>
          </div>
        )}
        <BQLink styleName="more-btn" href="/research-reports" className="container">
          <div
            styleName="btn"
            onClick={() =>
              loadMoreInteraction('View All Reports', userData, pageType, 'Research Reports')
            }
          >
            View All Reports &nbsp;
            <Icon path={mdiArrowRight} size="20px" color="#725E42" />
          </div>
        </BQLink>
      </div>
    </div>
  );
};

export default ResearchReports;
